import { useWYSIWYGContext } from '../contexts/WYSIWYGContext';
import { FullDocStyleData, getStylesFullDoc } from '../utils';

export const defaultFullDoc: FullDocStyleData = {
  bodyClasses: '',
  headStyles: '',
  headStylesheets: [],
};

export const useStylesFullDoc = (): FullDocStyleData => {
  const { isFullHtmlDoc, contentValue } = useWYSIWYGContext();
  return isFullHtmlDoc ? getStylesFullDoc(contentValue) : defaultFullDoc;
};
